import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";
import { baseUrl } from "../../../../../config";

const UserLoginAPI = createApi({
  reducerPath: "UserLoginAPI",
  // baseQuery: baseUrl,
  // baseQuery: fetchBaseQuery({ baseUrl: baseUrl }),
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    credentials: "include", // :white_check_mark: This enables cookie/session credentials across origins
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),

  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: ({
        user_login_id,
        user_login_password,
        ip_address,
        current_location,
      }) => ({
        url: "login_user",
        method: "POST",
        body: {
          user_login_id,
          user_login_password,
          ip_address,
          current_location,
        },
      }),
    }),
  }),
});

export const { useLoginUserMutation } = UserLoginAPI;

export default UserLoginAPI;
